import { render, staticRenderFns } from "./FacilityBody.vue?vue&type=template&id=f3df5728&scoped=true&"
import script from "./FacilityBody.vue?vue&type=script&lang=js&"
export * from "./FacilityBody.vue?vue&type=script&lang=js&"
import style0 from "./FacilityBody.vue?vue&type=style&index=0&id=f3df5728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3df5728",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3df5728')) {
      api.createRecord('f3df5728', component.options)
    } else {
      api.reload('f3df5728', component.options)
    }
    module.hot.accept("./FacilityBody.vue?vue&type=template&id=f3df5728&scoped=true&", function () {
      api.rerender('f3df5728', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Organizers/Facility/FacilityBody.vue"
export default component.exports